/*** IMPORTS FROM imports-loader ***/
var global = window;

export { createDeflateEncoder } from './deflateEncoder';
export { startDeflateWorker, getDeflateWorkerStatus, resetDeflateWorkerState, } from './deflateWorker';
//# sourceMappingURL=index.js.map
